import { FileUpload, Text } from 'shell/components';

const FileUploadDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>FileUpload</Text>
            <FileUpload onChange={console.log} />
        </>
    );
};

export default FileUploadDemo;
